import FileReferenceDefinition from '../FileReferenceDefinition';

const definition: FileReferenceDefinition = {
  name: 'iOSAuthChallengeReceivedEventArgs',
  type: 'class',
  description: 'Event args for [iOSWebView.AuthChallengeReceived](/webview/iOSWebView#AuthChallengeReceived).',
  inheritsFrom: 'System.EventArgs',
  members: [
    {
      name: 'AuthChallenge',
      returns: 'IntPtr',
      type: 'property',
      description: 'Objective-C pointer to the native `(NSURLAuthenticationChallenge *) challenge` parameter passed to [webView:didReceiveAuthenticationChallenge:completionHandler:](https://developer.apple.com/documentation/webkit/wknavigationdelegate/webview(_:didreceive:completionhandler:)?language=objc)',
      seeAlso: '[NSURLAuthenticationChallenge](https://developer.apple.com/documentation/foundation/urlauthenticationchallenge?language=objc)'
    },
    {
      name: 'CompletionHandler',
      returns: 'IntPtr',
      type: 'property',
      description: 'Objective-C pointer to the native `(void (^)(enum NSURLSessionAuthChallengeDisposition, NSURLCredential *)) completionHandler` parameter passed to [webView:didReceiveAuthenticationChallenge:completionHandler:](https://developer.apple.com/documentation/webkit/wknavigationdelegate/webview(_:didreceive:completionhandler:)?language=objc)',
      seeAlso: [
        '[NSURLSessionAuthChallengeDisposition](https://developer.apple.com/documentation/foundation/nsurlsessionauthchallengedisposition?language=objc)',
        '[NSURLCredential](https://developer.apple.com/documentation/foundation/nsurlcredential?language=objc)'
      ]
    },
  ]
};
export default definition;
